<template>
  <div class="label" :style="{ 'background-color': bgColor, 'color': textColor }">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'OfferCardLabel',
  props: {
    bgColor: {
      type: String,
      default: '#F6A622'
    },
    textColor: {
      type: String,
      default: '#FFFFFF'
    }
  }
}
</script>

<style scoped lang="scss">
.label {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 100rem;
  padding: 1rem 2rem;
}
</style>
